
import styled, { keyframes } from 'styled-components';
import {
  DEFAULT_FONT,
  WHITE_COLOR,
  BLACK_COLOR,
  LIGHT_RED,
  DARK_RED,
  LIGHT_GREEN,
  DARK_GREEN,
  LIGHT_BLUE,
  DARK_BLUE,
} from '../../styles/variables';
import * as palette from '../../styles/variables';

const slideUp = keyframes`
from {
  opacity: 0;
  transform: translateY(100%);
} to {
  opacity: 1;
  transform: translateY(0%);
}`;

export const Container = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
`;

export const Sidebar = styled.div`
  width: 26vw;
  background: rgb(37, 41, 45);
  color: white;
  padding: 24px;
  margin-left: 5%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media only screen and (min-width: 2560px) {
    margin-left: 150px;
  }
`;

export const PDFPreview = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width : 74vw;
    position: relative;
`;

export const PDFHeader = styled.div`
  display: flex;
  flex-direction: row;
  height: 10%;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
  padding: 0px 20px;
`

export const ReturnButton = styled.button`
  z-index: 100
  padding: 10px 24px;
  background-color: #000;
  border: 2px solid white;
  color: white;
  border-radius: 12px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
  
  &:hover {
    background-color: #111827;
  }
`;

export const PDFContainer = styled.div`
    display: flex;
    justify-content: center;
    overflow: auto;
    height: 100%;
    width: 100%;
`;

export const SidebarTitle = styled.h2`
  color: white;
  margin-bottom: 15px;
  font-size: 22px;
`;

export const PreviewSection = styled.div`
  margin-top: 0px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

export const PreviewTitle = styled.h3`
  color: white;
  margin-bottom: 24px;
  font-size: 17px;
`;

export const DocumentListTitle = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  color: white;
  font-size: 17px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const RowSection = styled.div`
  margin-top: ${props => props.marginTop && '20px'};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${props => props.isPreview && 'space-between'};
  .swith-btn{
    color:white;
    display: flex;
    align-items: center;
  }
  .ant-btn,
  .ant-btn:hover,
  .ant-btn:focus,
  .ant-btn:active {
    outline: 0;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: uppercase;
    border-radius: 50px;
    background-color: ${props => props.releaseBtn ? '#6969d8' : '#ffeb3b'} ;
    border: #ffeb3b;
    color: ${props => props.releaseBtn ? 'white' : '#000'};
    min-width: 150px;
  }
  .ant-btn .anticon {
    font-size: 13px;
  }
  .ant-btn.preview {
    display: flex;
    align-items: center;
    justify-content: center;
    .anticon {
      margin-right: 10px !important;
    }
    p {
      font-size: 10px;
      font-weight: 700;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: #000;
    }
  }
  .error-message{
    color: #ff0000;
  }
  ${props => props.downloadPayload && `
    justify-content: flex-end;
    .ant-btn, .ant-btn:hover, .ant-btn:focus {
      background: transparent;
      color: #FF9D00;
    }
  `}
`;

export const DownloadButton = styled.div`
    outline: 0;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: uppercase;
    border-radius: 50px;
    background-color: #ffeb3b;
    border: #ffeb3b;
    color: #000;
    width: ${props => props.channel && '50%'};
    // min-width: 150px;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    height: 32px;
    padding: 0 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: ${props => props.disabled ? 'none' : 'all'};
    
    .ant-dropdown-menu {
      width: 300px;
      }
      .ant-dropdown-menu-item, .ant-dropdown-menu-submenu-title {
        font-weight: bold;
        font-size: 10px;
        padding: 6px 12px;
        margin: 1px 0px;
        text-wrap: wrap;
        
        &:hover {
          background: #8C52FF !important;
          color: white;
          }
          }
          .ant-dropdown-menu-item-group-title {
            font-size: 9px;
            }
            
            &.transaction-btn {
              margin: 0 10px;
              min-width: 190px;
              background-color: #6f55ff;
              border: #6f55ff;
              color: #ffffff;
              cursor: ${props => props.interactiveEditable ? 'pointer' : 'not-allowed'};
    }
    &.loading {
        width: 230px;
    }
    ${props => props.disabled && `
      opacity: 0.5;
    `};
`;

export const WindowGuide = styled.div`
  position: absolute;
  left: ${p => p.x}px;
  top: ${p => p.y}px;
  width: ${p => p.width}px;
  height: ${p => p.height}px;
  border: 2px dashed rgba(0, 0, 0, 0.3);
  pointer-events: none;
  z-index: 5;
`;

export const AddressOverlay = styled.div`
  position: absolute;
  left: ${p => p.x}px;
  top: ${p => p.y}px;
  background: rgba(255, 255, 255, 0.95);
  border: 2px solid ${p => (p.valid ? '#22c55e' : '#ef4444')};
  border-radius: 4px;
  // padding: 4px;
  cursor: move;
  z-index: 10;
  will-change: transform;
`;

export const AddressTextarea = styled.textarea`
  border: none;
  resize: none;
  outline: none;
  background: transparent;
  scrollbar-width: none;
  /* font styles from props */
  font-family: ${({ fontStyle }) =>
    fontStyle?.fontName
      ? `${fontStyle.fontName}, sans-serif !important`
      :  'sans-serif'};

  font-size: ${({ fontStyle, scale }) =>
    fontStyle?.fontSize ? `${fontStyle.fontSize * scale}px` : '12pt'};

  line-height: ${({ fontStyle }) =>
    fontStyle?.lineHeight ? `${fontStyle?.lineHeight}em` : '1.2em'};

  color: ${({ fontStyle }) =>
    fontStyle?.fontColor ?? '#000'};

  font-weight: ${({ fontStyle }) =>
    fontStyle?.bold ? '700' : '400'};

  font-style: ${({ fontStyle }) =>
    fontStyle?.italic ? 'italic' : 'normal'};

  text-decoration: ${({ fontStyle }) =>
    fontStyle?.underline ? 'underline' : 'none'};
`;


export const DocumentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
  overflow-y: auto;
  flex: 1;
  padding-right: 8px;
  scrollbar-width: none;
  // /* Mac-style scrollbar */
  // &::-webkit-scrollbar {
  //   width: 8px;
  //   background-color: transparent;
  // }

  // &::-webkit-scrollbar-track {
  //   background-color: transparent;
  // }

  // &::-webkit-scrollbar-thumb {
  //   border-radius: 8px;
  //   background-color: rgba(255, 255, 255, 0.2);
  //   border: 2px solid transparent;
  //   background-clip: content-box;
  // }

  // &::-webkit-scrollbar-thumb:hover {
  //   background-color: rgba(255, 255, 255, 0.4);
  // }
`;

export const DocumentItem = styled.div`
  background: ${props => (props.selected ? '#E6F0FF' : 'white')};
  border: 2px solid ${props => (props.selected ? '#1890ff' : 'transparent')};
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;

  &:hover {
    background: ${props => (props.selected ? '#E6F0FF' : '#f5f5f5')};
  }
`;

export const DocumentHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 4px;
  
  .anticon {
    color: #666;
    margin-top: 4px;
  }
`;

export const DocumentTitle = styled.div`
  font-weight: 600;
  color: #333;
  font-size: 14px;
`;

export const DocumentAddress = styled.div`
  color: #666;
  font-size: 12px;
  margin-left: 22px;
  margin-bottom: 8px;
  line-height: 1.4;
`;

export const DocumentMeta = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  margin-left: 22px;
  color: #888;
  font-size: 11px;
`;

export const NavigationButton = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 60px;
  background: rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  z-index: 100;
  border-radius: 4px;

  ${props => props.left ? 'left: 20px;' : 'right: 20px;'}

  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }

  ${props => props.disabled && `
    opacity: 0;
    pointer-events: none;
  `}

  .anticon {
    font-size: 24px;
    color: #666;
  }
`;

export const ExitButton = styled.div`
  z-index: 100;
  background-color: #000;
  border: 2px solid white;
  color: white;
  border-radius: 12px;
  padding: 10px 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
  }

  .anticon {
    font-size: 16px;
  }
`;

export const UpdateAddressButton = styled.div`
  z-index: 100;
  background: rgba(255, 234, 59, 0.8);
  color: #000;
  padding: 10px 24px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;

  &:hover {
    background: rgba(255, 234, 59, 1);
  }

  .anticon {
    font-size: 16px;
  }
`;

export const FontWarning = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 100;
  background: ##fffbe680;
  border: 1px solid #ffe58f
  color: #000;
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;

  &:hover {
    background: #ffe58f;
  }

  .anticon {
    font-size: 16px;
  }
`;

export const LoaderContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  background: rgba(255, 255, 255, 0.8);
  padding: 8px 16px;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
`;

export const InsertContainer = styled.div`
  display: flex;
  width: 50%;
`;

export const ShiftContainer = styled.div`
  display: flex;
  width: 50%;
  // .suffix {
  //   width: 40px;
  //   pointer-events: 'none';
  //   border-top-right-radius: 4px;
  //   border-bottom-right-radius: 4px;
  //   margin-left: -3px;
  // }
  .ant-select-selection--single .ant-select-selection__rendered {
    margin-right: 11px;
  }
`;

export const Suffix = styled.div`
  width: 40px;
  height: 32px;
  background: #ffeb3b;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  margin-left: -3px;
  color: #000;
  font-size: 14px;
  pointer-events: none;
`;

export const Prefix = styled.div`
  width: 40px;
  height: 32px;
  background: #e7e7e7;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  margin-right: -3px;

  .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after { 
    border-color: #fff;
  }
`;

export const UploadButton = styled.div`
  width: 40px;
  height: 32px;
  background: #ffeb3b;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  margin-left: -3px;
  &:hover {
    background: #ffe066;
  }

  .anticon {
    color: black;
    font-size: 16px;
    font-weight: bold;
  }
`;

export const Main = styled.div`
  background-color: ${WHITE_COLOR};
  height: 100vh;
  width: calc(100vw - 5%);
  margin-left: 5%;
  box-sizing: border-box;
  font-family: ${DEFAULT_FONT}, sans-serif;
  font-weight: 500;
  color: ${BLACK_COLOR};
  display: flex;

  .batchList {
    height: 90vh;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding: 24px;
    row-gap: 24px;
    column-gap: 24px;
    justify-content: ${({justifyContent}) => justifyContent ?? 'flex-start'};
    overflow-y: auto;

    &.collapse {
      .anticon.anticon-arrow-up {
        right: 23%;
      }
    }

    &.expand {
      width: 100%;
    }

    .fade-enter {
      opacity: 0;
      transform: translateX(100%);
    }
    .fade-enter-active {
      opacity: 1;
      transform: translateX(0%);
    }
    .fade-exit {
      opacity: 1;
      transform: translateX(0%);
    }
    .fade-exit-active {
      opacity: 0;
      transform: translateX(-100%);
    }
    .fade-enter-active,
    .fade-exit-active {
      transition: opacity 300ms, transform 300ms;
    }

  }

  .customHeight {
    height: 100%;
  }

  .flexCenter {
    justify-content: center;
  }
`;

export const HybridContainer = styled.div`
  width: 100%;
  height: 100%;
  transition: width 0.3s ease-in-out;

  &.expand {
  }

  &.collapse {
    width: 75%;
  }
`;

export const SendLetterTitle = styled.div`
  font-size: 30px !important;
  color: black;
  text-transform: capitalize;
  font-weight: 400;
  margin: 0 !important;
  text-align: center;
  font-family: ${palette.FONT_FAMILY_TEMPLATE};
  background: ${props => props.isBatch && 'rgb(37,41,45)'};
  position: ${props => props.isBatch && 'absolute'};
  top: ${props => props.isBatch && '0'};
  width: ${props => props.isBatch && '100%'};
  padding-top: 25px;
  @media only screen and (min-width: 2560px) {
    font-size: 50px !important;
  }
  @media only screen and (min-width: 1460px) {
    font-size: 40px !important;
  }
`;

export const Header = styled.div`
  height: ${props => props.height};
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: ${props => props.justifyContent};
  position: relative;
  transition: 300ms ease width;
  padding: ${props => props.padding};
  cursor: ${props => props.isLoading ? "not-allowed" : "all"};
  z-index: 2;
  .title {
    font-size: 50px;
    font-weight: 400;
    color: #000;
    font-family: ${palette.FONT_FAMILY_TEMPLATE};
    font-family: ${palette.FONT_FAMILY_TEMPLATE};
    @media (max-width: 800px) {
      top: auto;
      bottom: 0;
      font-size: 2.4rem;
    }
    @media (max-width: 600px) {
      font-size: 6vw;
    }
  }
  .overlayScreenTitle {
    font-size: 22px;
    font-weight: 600;
    text-transform: uppercase;
  }
  .batchInputs {
    display: flex;
    flex-direction: column;
    .ant-input[disabled] {
      background-color: ${WHITE_COLOR};
    }
    .editableBatchName,
    .editableBatchDescription {
      width: 250px;
      color: ${BLACK_COLOR};
      font-size: 18px;
      font-weight: 700;
      font-family: ${DEFAULT_FONT} !important;
      border: 0;
      border-radius: 0;
      padding: 4px 0;
      border-bottom: 1px solid #d9d9d9;
    }
    .editableBatchDescription {
      width: 310px;
      font-size: 14px;
      font-weight: 400;
      text-transform: none;
      margin-top: 12px;
    }
  }
`;

export const Card = styled.div`
  display: flex;
  justify-content: ${props => (props.justifyContent ? props.justifyContent : 'space-between')};
  align-items: ${props => (props.alignItems ? props.alignItems : 'center')};
  flex-direction: ${props => (props.flexDirection ? props.flexDirection : 'column')};
  background: ${props => (props.bgColor ? props.bgColor : WHITE_COLOR)};
  height: ${props => props.height};
  width: ${props => props.width};
  padding: ${props => (props.padding ? props.padding : '0px')};
  border-radius: ${props => (props.borderRadius ? props.borderRadius : '24px')};
  cursor: ${props => props.cursorPointer && 'pointer'};
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  outline: ${props => props.selected ? `2px solid ${DARK_RED}` : ""};
  overflow: hidden;
  position: relative;
  animation: ${props => props.animation && slideUp} ${props => props.animationDelay} ease;
  border: ${props => props.selected && `2px outset ${LIGHT_RED}`};

  &.createBatchCard {
    align-items: normal;
  }

  .cardBody {
    display: flex;
    height: 100%;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;
    gap: 30px;
  }

  &.hoverScale {
    transition: scale 0.2s ease-in-out;
    &:hover {
      scale: 1.1;

      p {
        text-decoration: underline;
      }
    }
  }

  //FAILURE COUNT & DELETE DOCUMENTS CARDS
  .failureCount,
  .deleteDocuments {
    p {
      font-size: 12px;
    }
  }
  .failureCount {
    h3 {
      color: ${DARK_RED};
      font-size: 16px;
      font-weight: 700;
      .ant-spin-dot-item {
        background-color: ${DARK_RED};
      }
    }
  }
  .failureIcon {
    svg {
      padding-top: 4px;
      width: 28px;
      height: 32px;
    }
  }
  .deleteDocuments {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    row-gap: 8px;
    color: ${BLACK_COLOR};
    svg {
      color: ${DARK_RED};
      width: 20px;
      height: 20px;
    }
  }

  //BATCH LIST CARDS DESIGN
  .createCard {
    width: 100%;
    text-align: left;
  }
  .anticon {
    color: rgb(255, 51, 51);
  }
  .ant-btn {
    color: ${BLACK_COLOR};
    font-family: ${DEFAULT_FONT}, sans-serif !important;
    font-weight: 600;
  }
  .ant-btn:first-child {
    border-radius: 8px;
  }
  .ant-btn:last-child {
    font-size: 0.8rem;
    border-radius: 10px;
  }
  .createBatchTitle {
    padding: 6px 0;
    font-size: 0.9rem;
    font-weight: 600;
  }
  .createBatchDescription {
    font-size: 0.8rem;
  }
  .ant-progress {
    display: block;
  }
  .ant-progress-outer {
    display: block;
  }
  .ant-progress-inner {
    display: block;
    height: 6px;
    border-radius: 0;
  }
  .createdOn {
    font-size: 0.7rem;
    color: #737373;
    font-weight: 600;
  }

  &.batchCard {
    * {
     color: rgba(0, 0, 0, 0.65);
    }
  }

  .batchTitle {
    font-size: 1.2rem;
    font-weight: 600;
    text-align: center;
    width: ${props => `calc(${props.width} - 40px)`};
    white-space: nowrap;  
    overflow: hidden;
    text-overflow: ellipsis;
    :hover {
      cursor: pointer;
      text-decoration: underline;
      text-underline-position: under;
    }
  }
  .batchDescription {
    width: 280px;
    font-size: 0.8rem;
    font-style: italic;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 0 8px;
    text-align: center;
  }
  .batchDetails {
    display: flex;
    flex-direction: column;
    row-gap: 6px;
    width: 100%;
    padding: 0 38px;
    div {
      display: flex;
      column-gap: 10px;
      svg {
        height: 18px;
        width: 18px;
      }
      p {
        font-size: 0.8rem;
        max-width: 175px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        :nth-child(2) {
          font-weight: 700;
        }
      }
    }
  }
  .batchStats {
    display: flex;
    justify-content: center;
    column-gap: 1px;
    div {
      background-color: ${props =>
        props.status === 'exception'
          ? LIGHT_RED
          : props.status === 'active'
          ? LIGHT_BLUE
          : props.status === 'success' && LIGHT_GREEN};
      padding: 8px 0;
      width: 80px;
      text-align: center;
    }
    div:first-child {
      border-radius: 10px 0 0 10px;
    }
    div:last-child {
      border-radius: 0 10px 10px 0;
    }
    h2 {
      font-size: 1rem;
      font-weight: 700;
      color: ${props =>
        props.status === 'exception'
          ? DARK_RED
          : props.status === 'active'
          ? DARK_BLUE
          : props.status === 'success' && DARK_GREEN};
    }
    p {
      font-size: 0.7rem;
      text-transform: uppercase;
    }
  }
  .appliedFilterButton {
    background-color: ${WHITE_COLOR};
    border: 0;
    outline: 0;
    padding: 12px 0;
    position: relative;
    font-weight: 600;
    span {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 0.7rem !important;
      font-family: ${DEFAULT_FONT} !important;
      width: max-content;
      z-index: 2;
      :hover {
        cursor: pointer;
        text-decoration: underline;
        text-underline-position: under;
      }
    }
  }
  .appliedFilters {
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
    background-color: rgba(255, 255, 255, 94%);
    transform: translateY(100%);
    transition: transform 300ms ease;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 24px;
    border-radius: 24px;
    table {
      font-size: 0.8rem;
      th {
        font-weight: 700;
        text-decoration: underline;
        text-underline-position: under;
      }
      tr {
        .tagsList {
          display: flex !important;
          align-items: center;
          justify-content: flex-start;
          flex-wrap: wrap;
          row-gap: 2px;
        }
        td {
          padding: 2px 0;
          font-size: 0.8rem;
          .moreTags {
            font-size: 10px;
            padding: 6px 5px;
            border-radius: 8px;
            white-space: nowrap;
            background-color: ${LIGHT_GREEN};
          }
          .tags {
            font-size: 0.7rem;
            margin-right: 5px;
            padding: 6px 10px;
            border-radius: 8px;
            line-height: normal;
            background-color: ${LIGHT_GREEN};
          }
        }
        td:nth-child(1) {
          font-weight: 700;
        }
      }
    }
  }
  .appliedFilterButton:hover + .appliedFilters {
    transform: translateY(0%);
  }

  //DOCUMENTS LIST CARDS DESIGN
  .styledDiv {
    height: 106px;
    width: 106px;
    position: absolute;
    left: -35px;
    transform: rotate(45deg);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 22px;
    padding: 0 0 20px 20px;
    background-color: ${props => props.randomColor};
    svg {
      height: 32px;
      width: 32px;
      transform: rotate(-45deg);
    }
  }
  .textContainer {
    padding-left: 82px;
    margin: auto 0;
    width: 94%;
  }
  .date {
    font-size: .8rem;
    font-weight: 600;
    color: #B5B2B2;
  }
  .docName {
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 0.25px;
    display: flex;
    align-items: center;
    .name {
      font-size: 15px;
      font-weight: 700;
      letter-spacing: 0.25px;
      max-width: 175x;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      a {
        color: ${BLACK_COLOR}A6;
        text-decoration: none;

        :hover {
          text-decoration: underline;
        }
      }
    }
  }
  .pageCount {
    float: right;
    background: #f2f2f2;
    display: flex;
    align-items: center;
    column-gap: 4px;
    padding: 4px 8px;
    border-radius: 8px;
    display: flex;
    margin-top: 8px;
    p {
      font-size: 10px;
    }
  }
  svg {
    height: 16px;
    width: 16px;
  }

  //PRINTER LIST CARD DESIGN
  .printerIcon {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 58px;
    width: 58px;
    background-color: ${props => props.color};
    border-radius: 10px;
    svg {
      height: 24px;
      width: 24px;
    }
  }
  .printerDetails {
    text-align: center;
    .name {
      font-size: 14px !important;
      color: ${BLACK_COLOR};
      padding: 4px 0;
      font-weight: 700;
    }
    .ipAddress {
      font-size: 12px !important;
      letter-spacing: 0.25px;
      color: #a7a4a4;
      font-weight: 600;
    }
  }
`;

export const DataLoader = styled.div`
  width: 100%;
  text-align: center;
`;

export const UploadContentWrapper = styled.div`
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 60%;
  min-width: 320px;
  
  @media only screen and (max-width: 1440px) {
    width: 80%;
    padding: 20px;
  }
`;

export const BulkUploadButton = styled.div`
  border: 1px dotted #949494;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: ${props => (props.isUploading ? '11px' : '11px')};
  font-weight: ${props => props.isUploading && '700'};
  width: 85%;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  @media only screen and (min-width: 2560px) {
    padding: 300px;
    height: 700px !important;
    width: 100%;
  }
  @media only screen and (min-width: 1441px) and (max-width: 2559px) {
    height: 450px !important;
    padding: 150px;
    width: 100%;
  }
  @media only screen and (max-width: 1440px) {
    padding: 80px !important;
    height: 300px !important;
    width: 100%;
  }
  
  .downloadZip {
    cursor: pointer;
  }
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    .anticon {
      font-size: 45px;
      color: #000000;
    }
  }
  .import {
    font-size: 14px;
    font-weight: 700;
  }
  p.desc {
    font-size: 11px;
    text-transform: initial;
    font-weight: 400;
    color: #979696;
  }
`;